// jQuery est déjà chargé par WordPress, on peut l'utiliser directement
const $ = window.jQuery;

import AOS from "aos"; // Désactiver AOS

// IMPORT DES COMPONENTS
//import "./components/_mobile-menu";
import "./components/_mobile-menu";
import Popup from "./components/_popup";
import "./components/_cart-handler";
import "./components/_faq";
import "./components/_brand-features";
import "./components/_tabs";
import "./components/_accessories-swiper";
import "./components/_testimonials-swiper";
import "./components/_add-to-cart-ajax";
import "./components/_language-currency-popup";
import "./components/_wc-notices-popup"; // <- ajouter

// IMPORT DES PAGES
import { frontPage } from "./pages/front-page";
import { wcSingleProduct } from "./pages/wc-single-product";
import { wcProductCat } from "./pages/wc-product-cat";

const initApp = () => {
    let bodyClassList = document.getElementsByTagName("body")[0].classList;
    switch (true) {
        case bodyClassList.contains("page-template-front-page"):
            frontPage.readyFn();
            break;
        case bodyClassList.contains("single-product"):
            wcSingleProduct.readyFn();
            break;
        case bodyClassList.contains("tax-product_cat"):
            wcProductCat.readyFn();
            break;
        default:
    }
};

// ----------------------------------- DOCUMENT READY -----------------------------------
// --------------------------------------------------------------------------------------
jQuery(function () {

    AOS.init();
    Popup.init();

    initApp();

});

// ----------------------------------- WINDOW LOAD --------------------------------------
// --------------------------------------------------------------------------------------
$(window).on("load", function () {

    // Smooth scroll sur les ancres
    $('a[href*="#"]:not([href="#"])').on('click', function (e) {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top - 200 // Offset pour le header fixe
                }, 600); // Durée en ms
            }
        }
    });

});